export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 3_02.c1569d70.jpg";